import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import Roles from '@shared/constants/roles';

@Component({
  selector: 'app-concealed-damage-photo',
  templateUrl: './concealed-damage-photo.component.html',
  styleUrls: ['./concealed-damage-photo.component.scss']
})
export class ConcealedDamagePhotoComponent extends DialogBase implements OnInit {
  readonly roles = Roles;

  initInfo: any;
  fileInfo: any;
  imageInfo: any;
  comment: any;

  ngOnInit(): void {
    this.comment = this.fileInfo?.comment;
    this.imageInfo = this.apiService.concealedDamage.fileUrl(this.fileInfo?.file, 'inline');

  }

  save() {
    const { ticketNo } = this.initInfo;
    const data = { comment: this.comment, fieldname: this.fileInfo?.fieldName };

    this.spinnerService.start();
    this.apiService.concealedDamage.updateComment(ticketNo, data)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.onClose.next(data);
        this.bsModalRef.hide();
      }, err => Utils.showError(err));
  }

}
